import { useState } from "react";
import { useLocation } from "react-router-dom";
import { api, normaliseMobile, isValidMobile, isValidEmail, formatError } from "../lib/api";

export function useLeadForm({ source, initial = {}, requireConsent = false }) {
  const location = useLocation();
  const [values, setValues] = useState({ full_name: "", mobile: "", email: "", message: "", website: "", consent: false, ...initial });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [serverError, setServerError] = useState("");

  const set = (k) => (e) => {
    const v = e?.target ? (e.target.type === "checkbox" ? e.target.checked : e.target.value) : e;
    setValues((s) => ({ ...s, [k]: v }));
    setErrors((s) => ({ ...s, [k]: undefined }));
  };

  const validate = () => {
    const err = {};
    const name = values.full_name.trim();
    if (name.length < 2 || name.length > 80) err.full_name = "Please enter your full name (2–80 characters).";
    if (!isValidMobile(values.mobile)) err.mobile = "Enter a valid 10-digit Indian mobile number.";
    if (values.email && !isValidEmail(values.email)) err.email = "Enter a valid email address.";
    if (requireConsent && !values.consent) err.consent = "Please agree to be contacted.";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const submit = async (e) => {
    e?.preventDefault();
    if (!validate()) return false;
    setStatus("loading");
    setServerError("");
    try {
      await api.post("/leads", {
        ...values,
        full_name: values.full_name.trim(),
        mobile: normaliseMobile(values.mobile),
        email: values.email.trim(),
        source,
        page_url: window.location.origin + location.pathname,
      });
      setStatus("success");
      return true;
    } catch (err) {
      setStatus("error");
      setServerError(formatError(err.response?.data?.detail) || err.message);
      return false;
    }
  };

  const reset = () => { setStatus("idle"); setValues({ full_name: "", mobile: "", email: "", message: "", website: "", consent: false, ...initial }); };

  return { values, errors, status, serverError, set, submit, reset };
}
